import { QueryClient } from '@tanstack/react-query';

import { EP_STORES_LIST } from 'modules/endpoints';
import Warehouses from 'modules/warehouse';

export const setupWHQueryDefaults = (queryClient: QueryClient) => {
  queryClient.setQueryDefaults([EP_STORES_LIST], { queryFn: Warehouses.list, staleTime: Infinity });
  queryClient.setQueryDefaults([EP_STORES_LIST + 'jahez_status' + 'deliveroo_status'], {
    queryFn: () => Warehouses.listWithPartnersStatus(true, true),
    staleTime: Infinity
  });
};
